import { useStage } from './useStage'

export default () => useStage('survey')
